module.exports = __webpack_public_path__ + "img/ThermalLeatherArmor.50e9fcf2.gif";